var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.54733 1.78743C7.79727 1.53749 8.2025 1.53749 8.45243 1.78743L10.3724 3.70743C10.6224 3.95736 10.6224 4.36259 10.3724 4.61252C10.1225 4.86246 9.71727 4.86246 9.46733 4.61252L8.63988 3.78507V9.91998C8.63988 10.2734 8.35334 10.56 7.99988 10.56C7.64642 10.56 7.35988 10.2734 7.35988 9.91998V3.78507L6.53243 4.61252C6.2825 4.86246 5.87727 4.86246 5.62733 4.61252C5.3774 4.36259 5.3774 3.95736 5.62733 3.70743L7.54733 1.78743Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87988 7.35998C2.87988 6.65305 3.45296 6.07998 4.15988 6.07998H5.43988C5.79334 6.07998 6.07988 6.36651 6.07988 6.71998C6.07988 7.07344 5.79334 7.35998 5.43988 7.35998H4.15988V13.12H11.8399V7.35998H10.5599C10.2064 7.35998 9.91988 7.07344 9.91988 6.71998C9.91988 6.36651 10.2064 6.07998 10.5599 6.07998H11.8399C12.5468 6.07998 13.1199 6.65305 13.1199 7.35998V13.12C13.1199 13.8269 12.5468 14.4 11.8399 14.4H4.15988C3.45296 14.4 2.87988 13.8269 2.87988 13.12V7.35998Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.922dfb2035005d853482a7bc0bef3d3b.svg";
export { ForwardRef as ReactComponent };